"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClearRoomActionHandler = exports.ClearRoomActionArgs = void 0;
const __1 = require("../../..");
const Demand_1 = require("../../Demand");
const Registries_1 = require("../../state/Registries");
const ActionType_1 = require("../ActionType");
class ClearRoomActionArgs {
    constructor(roomId) {
        this.roomId = roomId;
        this.__type = ActionType_1.ActionType.ClearRoom;
        this.__typeName = "ClearRoom";
    }
}
exports.ClearRoomActionArgs = ClearRoomActionArgs;
let ClearRoomActionHandler = class ClearRoomActionHandler {
    activate(sequence, container, action) {
        const room = container.getRoom(action.args.roomId);
        (0, Demand_1.demand)(!!room, "ROOM_MUST_EXIST");
        (0, Demand_1.demand)(room.state === "Active", "ROOM_ALREADY_COMPLETED");
        room.state = "Cleared";
        container.emitEvent(sequence, container.adventure.id, new __1.RoomClearedEventArgs(action.args.roomId));
    }
};
ClearRoomActionHandler = __decorate([
    Registries_1.Actions.register(ActionType_1.ActionType.ClearRoom)
], ClearRoomActionHandler);
exports.ClearRoomActionHandler = ClearRoomActionHandler;
